import React,{useState,useEffect} from 'react';
import './style.css';
import {Ingress, 
        IngressIconColor, 
        EgressIconColor, 
        formatDate, 
        deleteButtonText, 
        editButtonText, 
        ROUTE_API,
        replaceElement,
        filterDate,
    } 
    from '../../Constants/index';
import * as MdIcons from "react-icons/md";
import Axios from 'axios';
import FormUpdate from '../FormUpdate/index';
import Filter from '../../Component/Filter/index'
import swal from 'sweetalert';
import ModalError from '../../Component/ModalError';

const GlobalTable = () => {
    
    const [show, setShow] = useState (false)
    const [currentList, setCurrentList] = useState()
    const [idItem, setIdItem] = useState('')
    const [editBlock, setEditBlock] = useState(false)
    
    
    useEffect(() => {
        Axios.get(`${ROUTE_API}/getAllRegisters/${localStorage.getItem('idUser')}`).then((response) => {
            setCurrentList(response.data)
        })
        
    }, []);

    const editItem = (id) =>  {
        if(editBlock){
            swal({
                title: "No puede editar otra forma",
                text: "Quiere cancelar esta operación?",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            }).then((change) => {
            if (change) {
                setIdItem(id)
                setEditBlock(true)
                setShow(!show)
            }
        })
            }else{
        swal({
            title: "Está seguro?",
            text: `Va a editar este registro!`,
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
        .then((edit) => {
            if (edit) {
                setIdItem(id)
                setEditBlock(true)
                setShow(!show)
            } else {
                swal("Su registro no fue editado");
                }
            });  
        }  
    }

    const handleItems = (e, value) => {
        setShow(e)
        setEditBlock(e)
        setCurrentList(replaceElement(currentList,value))
    }


    const handleDate = (e) => {
        setCurrentList(filterDate(currentList, e.date, e.amount))
    }


    const restoreList = (e) => {
        window.location.reload(); 
    }




    const deleteRecord = (id) => {
        swal({
            title: "Está seguro?",
            text: "Una vez borrado no podrá recuperar este registro!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
        .then((willDelete) => {
            if (willDelete) {
                Axios.delete(`${ROUTE_API}/deleteRecord/${id}`).then((response) => {
                    setCurrentList(currentList?.filter((value) => {
                        return value.id !== id;
                    }))
                    console.log(response)
                })
                swal("Su registro ha sido borrado!", {
                icon: "success",
            });
            } else {
                swal("Su registro no fue borrado");
            }
        });
    }

    return (
        <>
            <div className="formRecordContainer">
                {show &&  
                <FormUpdate 
                    id={idItem}
                    uniqueItem={currentList?.filter(item => item.id === idItem)}
                    handleItem={handleItems}
                />
                }
                <Filter 
                changeDate={handleDate}
                restore={restoreList}
                estado={currentList}
                />
            </div>
            
        <div className="MainGlobalTable" style={{'overflowX':'auto'}}>
        {currentList?.length !== 0 ? (
            <table className="styledTable">
                <thead>
                    <tr>
                        <th>Concepto</th>
                        <th>Monto</th>
                        <th>Fecha</th>
                        <th>Tipo</th>
                        <th>Borrar</th>
                        <th>Editar</th>
                    </tr>
                </thead>
            <tbody>

        {currentList?.map((item,index) => {
            return (
                    <tr key={index}>
                        <td>{item.concept}</td>
                        <td style={item.types === Ingress ?{color:IngressIconColor} : {color:EgressIconColor}}>{item.amount}</td>
                        <td>{formatDate(item.date)}</td>
                        <td>{item.types === Ingress ? <MdIcons.MdAttachMoney color={IngressIconColor}/> : <MdIcons.MdMoneyOff color={EgressIconColor}/>}</td>
                        <td><button className="operationButton" onClick={() => deleteRecord(item.id)}>Borrar</button></td>
                        <td><button id="editButton" className="operationButton" onClick={() => editItem(item.id)}>Editar</button></td>
                    </tr>
            )
        })}
                </tbody>
            </table>
                ) : (<ModalError text={'REGISTRO NO ENCONTRADO'}/>)}
        </div>
    </>
    )
}

export default  GlobalTable


